
import { defineComponent } from "vue";

export default defineComponent({
  name: "MindGamesHeader",

  data() {
    return {
      headlineValues: ["MiNd", "GAmES"] as Array<string>,
    };
  },

  methods: {
    //TODO: text scrable for headline
  },
});
